import { PencilSimple, Plus } from '@phosphor-icons/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { ICustomFilter } from 'core/types';
import { Variant } from 'theme/enums';

import { UpsertFilter } from './UpsertFilter';

interface IProps {
  entity: string;
  currentConfig: string;
  filter?: ICustomFilter;
  onSubmitSuccess?: (filter: ICustomFilter) => void;
}

export const UpsertFilterButton = ({ entity, currentConfig, filter, onSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const isEdit = useMemo(() => !!filter?.id, [filter]);

  return (
    <>
      <Button
        text={isEdit ? t('buttonLabelEdit') : t('buttonLabelAddFilter')}
        variant={Variant.PLAIN}
        startDecorator={isEdit ? <PencilSimple /> : <Plus />}
        onClick={() => setIsOpen(true)}
      />

      <UpsertFilter
        entity={entity}
        currentConfig={currentConfig}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
        filter={filter}
      />
    </>
  );
};
